import { useActiveOrganization } from "@/core/context/ActiveOrganizationContext"
import { useActiveProduct } from "@/core/context/ActiveProductContext"
import usePermissions from "@utils/hook/usePermissions"

export default function useActiveProductOrOrganizationPermissions() {
  const activeProduct = useActiveProduct()
  const activeOrganization = useActiveOrganization()
  return usePermissions(activeProduct || activeOrganization)
}
